import React from 'react';
import { useIntl } from "react-intl";
import { BulkTestPageParam } from "@/model";
import { useAgentId, useModal, usePageParam } from "@/hook";
import { usePaginatedBulkTests } from "@/query/bulkTest";
import Button from "@/component/Button";
import { SearchBar } from "@/component/input";
import PaginationBar from "@/component/PaginationBar";
import { AddIcon } from "@/assets/svgs/icons";

import BulkTestTable from "./component/BulkTestTable";
import UploadTestCaseModal, { TEST_UPLOAD_MODAL_ID } from "./component/UploadTestCaseModal";


const BULK_TEST_PAGE_SIZE = 15;

const BulkTestView: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();

    const { param, set: setParam } = usePageParam<BulkTestPageParam>({
        page: 0,
        size: BULK_TEST_PAGE_SIZE,
        sortKey: "created_at",
        sort: "desc",
    });

    const { data: bulkTestPage } = usePaginatedBulkTests(
        agentId,
        param?.page,
        param?.size,
        param?.sortKey,
        param?.sort,
        param?.status,
        param?.keyword
    );

    const onChangeSort = (key: BulkTestPageParam["sortKey"]) => {
        if (param?.sortKey === key) {
            setParam({
                sort: param?.sort === "desc" ? "asc" : "desc"
            });
        } else {
            setParam({
                sortKey: key
            });
        }
    };

    return (<>
        <UploadTestCaseModal />

        <div className="agent-content-layout flex flex-col gap-3">
            <div className="search-bar-container w-md-page pr-0">
                <SearchBar lg width={680}
                           onSearch={keyword => setParam({ keyword: keyword })}
                           placeholder={intl.formatMessage({ id: "i09004" })}
                />

                <div className="search-bar-container-btn-group">
                    <Button variant="text"
                            onClick={() => modal.open(TEST_UPLOAD_MODAL_ID)}
                    >
                        <AddIcon className="size-3.5" />
                        {intl.formatMessage({ id: "i09002" })}
                    </Button>
                </div>
            </div>

            <div className="table-pagination-container w-md-page h-full">
                <BulkTestTable page={bulkTestPage}
                               pageParam={param}
                               onClickSortHead={onChangeSort}
                />
                <PaginationBar pageData={bulkTestPage}
                               onClickPage={page => setParam({ page: page })}
                />
            </div>
        </div>
    </>);
};

export default BulkTestView;
